module.exports = __webpack_public_path__ + "static/media/parking.50e7c5dd.svg";